import { Inject, Injectable } from '@angular/core';
import { getDate8AsInt, getId } from '@cawita/core-front';
import { CustomizationSettings, Stay } from '@shared/models';
import { GenericCrudService, getCrudName } from '@shared/modules/crud';
import { map } from 'rxjs/operators';
import { CWT_APP_CONFIG, CwtAppConfig } from '@mobile/modules/core/core-app.config';

@Injectable({ providedIn: 'root' })
export class StayAPI {
    constructor(
        @Inject(CWT_APP_CONFIG) private appConfig: CwtAppConfig,
        @Inject(getCrudName(Stay)) private stayCrud: GenericCrudService<Stay>,
        @Inject(getCrudName(CustomizationSettings)) private customizationSettingsCrud: GenericCrudService<Stay>,
    ) { }

    public create(stay: Partial<Stay>) {
        return this.stayCrud.create(stay, {
            options: {
                projection: this.appConfig.stay.projection,
            }
        })
    }

    public update(id: string, stay: Partial<Stay>) {
        return this.stayCrud.update(id, stay, {
            options: {
                projection: this.appConfig.stay.projection,
            }
        })
    }

    public getNonExpired() {
        return this.stayCrud.getAllNoPaginate({}, {
            bypassCache: true,
            options: {
                projection: this.appConfig.stay.projection,
                sort: 'startDate'
            }
        }).pipe(
            map(stays => {
                const now = getDate8AsInt(new Date());
                return stays.filter(s => !s.endDate || s.endDate >= now)
            })
        );
    }

    public getStayCustomization(stay: Stay) {
        return this.customizationSettingsCrud.getAllNoPaginate({
            partner: getId(stay.camping)
        }, {
            bypassCache: true
        }).pipe(
            map(settings => settings[0]),
        );
    }
}